export const visit = (vm, at) => {
at({ "es": { "uiAddonTeams": { "teamSelectLabelOne": "1 equipo seleccionado", "teamSelectLabelMany": "{{ count }} equipos seleccionados", "selectTeams": "Seleccionar equipos", "selectAll": "Seleccionar todo ({{ teamName }})" } } });
};